import { RetargetingGoal } from '../../typings/domain';
import { Goal } from '../../typings/goals';

export function getGoalNameWithDomain(goal: RetargetingGoal | Goal): string {
    return [goal.domain, goal.name].filter(val => val !== undefined).join(' :: ');
}
